(function () {
  if (customElements.get('color-compare-carousel')) return;

  class ColorCompareCarousel extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.viewport = this.querySelector('.ccc__viewport');
      this.track = this.querySelector('.ccc__track');
      this.cards = Array.from(this.querySelectorAll('.ccc__card'));
      this.swatches = Array.from(this.querySelectorAll('.ccc__swatch'));
      if (!this.viewport || this.cards.length === 0) return;

      this.colorPos = parseInt(this.dataset.colorOptionPosition, 10) || 1;
      this.colorName = this.dataset.colorOptionName || '';
      this.mqMobile = window.matchMedia('(max-width: 749px)');
      this.infinite = this.cards.length > 1;   // revolving loop (visual only)
      this.step = 300;
      this.maxSide = 3;
      this._dragActive = false;
      this._dragging = false;
      this._suppressClick = false;

      const initial = this.cards.findIndex(function (c) { return c.classList.contains('is-active'); });
      this.activeIndex = initial >= 0 ? initial : 0;

      // Away from the product's own page there is no buy box: the CTA is an
      // <a> to the PDP whose href follows the selected colour.
      this.linkMode = this.dataset.mode === 'link';

      // Locate the existing PDP variant picker (buy box) to drive & listen to.
      this.picker = this.linkMode
        ? null
        : document.querySelector('.main-product variant-radios, .main-product variant-selects')
          || document.querySelector('variant-radios, variant-selects');

      const self = this;
      this.cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (self._suppressClick) { e.preventDefault(); e.stopPropagation(); return; }
          self.onUserSelect(parseInt(card.dataset.index, 10));
        });
      });
      this.swatches.forEach(function (sw) {
        sw.addEventListener('click', function () { self.onUserSelect(parseInt(sw.dataset.index, 10)); });
      });
      this.buy = this.querySelector('[data-ccc-buy]');
      if (this.buy && !this.linkMode) {
        this.buy.addEventListener('click', function () { self.scrollToBuyBox(); });
      }

      // Pointer drag (desktop + mobile): swipe/drag through the coverflow.
      this.viewport.addEventListener('pointerdown', function (e) { self._onPointerDown(e); });
      this.viewport.addEventListener('pointermove', function (e) { self._onPointerMove(e); });
      window.addEventListener('pointerup', function (e) { self._onPointerUp(e); });
      window.addEventListener('pointercancel', function (e) { self._onPointerUp(e); });
      this.viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

      if (this.mqMobile.addEventListener) {
        this.mqMobile.addEventListener('change', function () { self.readMetrics(); self.render(); });
      }

      // Reverse sync: colour changed in the main buy box → reflect here.
      if (this.picker && this.picker.dataset.section) {
        document.addEventListener(this.picker.dataset.section + '-variant:change', function (e) {
          self.onExternalVariantChange(e.detail);
        });
      }

      // Re-layout on resize / when VWO reveals the section from display:none.
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(function () { self.render(); });
        this._ro.observe(this.viewport);
      } else {
        window.addEventListener('resize', function () { self.render(); });
      }

      this.render();
    }

    onUserSelect(index) {
      if (isNaN(index) || index < 0 || index >= this.cards.length) return;
      this.activeIndex = index;
      this.render();
      this.commitToPicker(index);
    }

    // Point the CTA at the PDP for the colour currently in view.
    updateBuyLink() {
      if (!this.linkMode || !this.buy) return;
      const card = this.cards[this.activeIndex];
      const url = card && card.dataset.variantUrl;
      if (url) this.buy.setAttribute('href', url);
    }

    // Drive the existing picker exactly as a real swatch click would.
    commitToPicker(index) {
      const card = this.cards[index];
      if (!this.picker || !card) return;
      const ovid = card.dataset.optionValueId;
      const val = card.dataset.colorValue;
      const vid = card.dataset.variantId;

      const radios = Array.from(this.picker.querySelectorAll('input[type="radio"]'));
      if (radios.length) {
        const input = radios.find(function (i) { return i.dataset.optionValueId === ovid; })
          || radios.find(function (i) { return i.name === this.colorName && i.value === val; }.bind(this))
          || radios.find(function (i) { return i.dataset.variantId === vid; });
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      const selects = Array.from(this.picker.querySelectorAll('select'));
      let select = selects.find(function (s) {
        return s.querySelector('option[data-option-value-id="' + (window.CSS && CSS.escape ? CSS.escape(ovid) : ovid) + '"]');
      });
      if (!select && this.colorName) {
        select = selects.find(function (s) { return s.name === 'options[' + this.colorName + ']'; }.bind(this));
      }
      if (select) {
        const opt = Array.from(select.options).find(function (o) { return o.dataset.optionValueId === ovid; })
          || Array.from(select.options).find(function (o) { return o.value === val; });
        if (opt && select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    onExternalVariantChange(variant) {
      if (!variant) return;
      const colorVal = variant['option' + this.colorPos];
      if (colorVal == null) return;
      const idx = this.cards.findIndex(function (c) { return c.dataset.colorValue === colorVal; });
      if (idx >= 0 && idx !== this.activeIndex) {
        this.activeIndex = idx;
        this.render();
      }
    }

    // Metrics recomputed on resize / breakpoint change (also when VWO reveals
    // the section from display:none, so offsetWidth becomes real).
    readMetrics() {
      const isMobile = this.mqMobile.matches;
      this.maxSide = isMobile ? 2 : 3;
      const activeCard = this.cards[this.activeIndex] || this.cards[0];
      const cw = activeCard ? activeCard.offsetWidth : 0;
      if (isMobile) {
        this.step = cw ? Math.round(cw * 0.62) : Math.round(window.innerWidth * 0.44);
      } else {
        this.step = parseInt(this.dataset.desktopStep, 10) || 300;
      }
    }

    render() {
      const self = this;
      this.cards.forEach(function (card, i) {
        card.classList.toggle('is-active', i === self.activeIndex);
      });
      this.swatches.forEach(function (sw, i) {
        sw.setAttribute('aria-selected', i === self.activeIndex ? 'true' : 'false');
      });
      this.updateBuyLink();
      this.readMetrics();
      if (!this._dragging) this.positionCards(this.activeIndex);
    }

    // Circular (infinite) offset: wrap far cards around to the near side so the
    // carousel always has neighbours on both sides, even on the first variant.
    circularOffset(off) {
      const n = this.cards.length;
      if (!this.infinite || n < 2) return off;
      off = off % n;
      if (off > n / 2) off -= n;
      else if (off < -n / 2) off += n;
      return off;
    }

    // Position every card relative to a (possibly fractional) centre index.
    // Shared by the settled state and live drag-follow. Cards are vertically
    // centred on the shared axis (translate -50% Y), neighbours scaled down.
    positionCards(center) {
      const self = this;
      this.cards.forEach(function (card, i) {
        const off = self.circularOffset(i - center);
        const abs = Math.abs(off);
        const scale = Math.max(1 - abs * 0.15, 0.4);
        const visible = abs <= self.maxSide + 0.5;
        const opacity = visible ? Math.max(1 - abs * 0.33, 0.04) : 0;
        card.style.transform = 'translate(-50%, -50%) translateX(' + (off * self.step) + 'px) scale(' + scale + ')';
        card.style.opacity = opacity;
        card.style.zIndex = String(100 - Math.round(abs));
        card.style.pointerEvents = visible ? 'auto' : 'none';
      });
    }

    wrapIndex(i) {
      const n = this.cards.length;
      return ((i % n) + n) % n;
    }

    _onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (this.cards.length < 2) return;
      this._dragActive = true;
      this._dragging = false;
      this._dragStartX = e.clientX;
      this._dragStartIndex = this.activeIndex;
      this._pointerId = e.pointerId;
    }

    _onPointerMove(e) {
      if (!this._dragActive) return;
      const dx = e.clientX - this._dragStartX;
      if (!this._dragging) {
        if (Math.abs(dx) < 8) return;   // tap-slop: below this it's a click, not a drag
        this._dragging = true;
        this.classList.add('is-dragging');
        try { this.viewport.setPointerCapture(this._pointerId); } catch (err) {}
      }
      if (e.cancelable) e.preventDefault();
      const step = this.step || 1;
      this.positionCards(this._dragStartIndex - dx / step);
    }

    _onPointerUp(e) {
      if (!this._dragActive) return;
      this._dragActive = false;
      try { this.viewport.releasePointerCapture(this._pointerId); } catch (err) {}
      if (!this._dragging) return;   // was a tap — let the card click handler run

      this._dragging = false;
      this.classList.remove('is-dragging');

      const dx = e.clientX - this._dragStartX;
      const step = this.step || 1;
      const newIndex = this.wrapIndex(Math.round(this._dragStartIndex - dx / step));

      // A real drag happened: block the click that would otherwise select a card.
      this._suppressClick = true;
      const self = this;
      setTimeout(function () { self._suppressClick = false; }, 80);

      if (newIndex !== this.activeIndex) {
        this.activeIndex = newIndex;
        this.render();
        this.commitToPicker(newIndex);   // settle → select the real variant (like the mobile swipe)
      } else {
        this.render();   // snap back into place
      }
    }

    scrollToBuyBox() {
      const target = document.querySelector('.main-product product-form')
        || document.querySelector('.main-product .product-form')
        || document.querySelector('.main-product');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  customElements.define('color-compare-carousel', ColorCompareCarousel);
})();
